import Cookies from 'js-cookie';

export const AUTH_REDIRECT_EXCLUDED_PATHS = [
  '/api/audit/update-activity',
  '/api/audit/active-users',
  '/api/audit/logout'
];

export const getSessionToken = () => Cookies.get('sessionToken') || null;

export const clearStoredAuth = () => {
  localStorage.removeItem('userData');

  Object.keys(Cookies.get()).forEach((cookieName) => {
    Cookies.remove(cookieName, { path: '/' });
  });
};

export const isLoginRoute = (pathname = window.location.pathname) => {
  return pathname === '/admin/login';
};

export const redirectToLogin = () => {
  window.location.href = '/admin/login';
};

export const clearAuthAndRedirect = ({ ignoreIfAlreadyOnLogin = true } = {}) => {
  if (ignoreIfAlreadyOnLogin && isLoginRoute()) {
    return false;
  }

  clearStoredAuth();
  redirectToLogin();
  return true;
};

export const shouldHandleAuthRedirect = (requestUrl) => {
  try {
    const parsedUrl = new URL(requestUrl, window.location.origin);
    return !AUTH_REDIRECT_EXCLUDED_PATHS.some((path) => parsedUrl.pathname === path);
  } catch {
    return true;
  }
};
